import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5893e84a")

_pushScopeId("data-v-5893e84a")
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createVNode("input", {
      class: "input-field txt",
      value: _ctx.modelValue,
      onInput: _cache[1] || (_cache[1] = (event) => _ctx.$emit('update:modelValue', event.target.value)),
      type: _ctx.type,
      placeholder: _ctx.placeholder
    }, null, 40, ["value", "type", "placeholder"])
  ]))
})